/* eslint-disable react/no-array-index-key */
import dstyled from 'astroturf';
var DocWrapper = /*#__PURE__*/dstyled('span', null, {
  displayName: "DocWrapper",
  styles: require("./DocTypeWrapper-DocWrapper.module.css"),
  attrs: null,
  vars: []
});
export default DocWrapper;